import { store } from '@core/store';

export class PermissionController {
  #allowedDefaultRoutes = [
    'dashboard',
    'not-found-page',
    'restaurant-management',
    'profile',
    'completion-detail',
    'completion',
    'userList',
    'product-master',
    'product-master-list',
    'eventList',
    'socialMedia',
    'socialList',
    'linkTree',
    'tableQr'
  ]

  static #instance = null;

  #availableRoutes = [];

  #functionalities = [];

  #matchesRoute(route, routeIncoming) {
    return route === routeIncoming;
  }

  haveRoutes() {
    return this.#availableRoutes.length > 0;
  }

  isAllowed(routeIncoming) {
    // First the default routes should always be allowed, as the app needs them.
    // If we find any routes available we allow it
    if (this.#availableRoutes.length > 0) {
      if (this.#availableRoutes.some((route) => this.#matchesRoute(route, routeIncoming))) {
        return true;
      }
    }

    if (this.#allowedDefaultRoutes.some((route) => this.#matchesRoute(route, routeIncoming))) {
      return true;
    }

    return false;
  }

  isPosAllowed(routeParams) {
    if (Object.prototype.hasOwnProperty.call(routeParams, 'pointOfSaleGuid') && store.getters.pointOfSaleList.length > 0) {
      const filteredPosList = store.getters.pointOfSaleList.filter((pos) => pos.guid === routeParams.pointOfSaleGuid);
      return filteredPosList.length > 0;
    }
    return true;
  }

  async addModules(availableFrontGroups) {
    await store.dispatch('setModuleStatus', false);
    this.#clearModules();
    const { allRoutes, allFunctionalities } = this.#handleRoutes(availableFrontGroups);
    this.#availableRoutes = allRoutes;
    this.#functionalities = allFunctionalities;
    await store.dispatch('setModuleStatus', true);
  }

  #handleRoutes(availableFrontGroups) {
    const allRoutes = [];
    const allFunctionalities = [];
    availableFrontGroups.forEach((frontGroup) => {
      frontGroup.availableFrontRoutes.forEach((frontRoutes) => {
        allRoutes.push(...frontRoutes.routes);
        allFunctionalities.push(...frontRoutes.functionalities);
      });
    });
    return { allRoutes, allFunctionalities };
  }

  #clearModules() {
    this.#availableRoutes = [];
    this.#functionalities = [];
  }

  getFunctionalities() {
    return this.#functionalities;
  }

  static initialize() {
    if (!this.#instance) {
      this.#instance = new PermissionController();
    }
  }

  static getInstance() {
    if (!this.#instance) {
      this.initialize();
    }
    return this.#instance;
  }
}
